(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // ====== VITAQFIT: Toggle búsqueda compacta en móvil ======
  (function() {
    const MQ_MOBILE = window.matchMedia('(max-width: 749px)');

    function initMobileSearch() {
      const toggles = document.querySelectorAll('.vitaqfit-header__search-toggle');
      toggles.forEach(function(btn) {
        const targetId = btn.getAttribute('aria-controls');
        const searchArea = document.getElementById(targetId);
        if (!searchArea) return;

        // Remover listener previo clonando el botón
        const newBtn = btn.cloneNode(true);
        btn.parentNode.replaceChild(newBtn, btn);

        newBtn.addEventListener('click', function() {
          const isExpanded = newBtn.getAttribute('aria-expanded') === 'true';
          if (isExpanded) {
            newBtn.setAttribute('aria-expanded', 'false');
            searchArea.classList.remove('is-expanded');
          } else {
            newBtn.setAttribute('aria-expanded', 'true');
            searchArea.classList.add('is-expanded');
            // Foco automático al input
            const input = searchArea.querySelector('.vitaqfit-search__input');
            if (input) setTimeout(function() { input.focus(); }, 50);
          }
        });
      });
    }

    function applyMobileSearch() {
      const searchAreas = document.querySelectorAll('[id^="vitaqfit-search-area-"]');
      const toggleBtns  = document.querySelectorAll('.vitaqfit-header__search-toggle');

      if (MQ_MOBILE.matches) {
        // En móvil: ocultar por defecto, activar toggle
        searchAreas.forEach(function(el) { el.classList.remove('is-expanded'); });
        toggleBtns.forEach(function(btn) { btn.style.display = ''; });
        initMobileSearch();
      } else {
        // En escritorio: siempre visible, ocultar botón toggle
        searchAreas.forEach(function(el) {
          el.classList.remove('is-expanded');
          el.style.display = '';
        });
        toggleBtns.forEach(function(btn) { btn.style.display = 'none'; });
      }
    }

    document.addEventListener('DOMContentLoaded', applyMobileSearch);
    MQ_MOBILE.addEventListener('change', applyMobileSearch);
  })();

  } catch(e) { console.error(e); }
})();
})();
